import { Col, Flex, notification, Row } from "antd";

import "./SubcontractorDashboard.scss";
import { useEffect } from "react";
import { SubcontractorDashboardProjectsCard } from "./subcontractor-dashboard-projects-card/SubcontractorDashboardProjectsCard";
import { useProjectsInfo } from "projects/queries";
import { NotesList } from "notes/components";
import { SalesTargetTimePeriods } from "users/components";
import variables from "../../../../_variables.scss";
import { useBoundStore } from "store";

export const SubcontractorDashboard = () => {
  const { currentOrganization } = useBoundStore();
  const {
    data: projectsInfo,
    isSuccess,
    error,
    refetch,
  } = useProjectsInfo(currentOrganization?.id);
  const [api, notificationContextHolder] = notification.useNotification();

  const onSalesTargetTimePeriodChange = () => {
    refetch();
  };

  useEffect(() => {
    if (error) {
      api.error({
        message: "Error",
        description: (error as Error)?.message,
      });
    }
  }, [error, api]);

  return (
    <Flex vertical gap={variables.largeGap}>
      {notificationContextHolder}
      <Flex>
        <SalesTargetTimePeriods
          name='sales-target-time-periods'
          onChange={onSalesTargetTimePeriodChange}
        />
      </Flex>
      <Row gutter={{ xs: 4, sm: 8, md: 16, lg: 32 }} justify={"space-between"}>
        <Col span={16}>
          <SubcontractorDashboardProjectsCard
            loading={!isSuccess}
            subcontractorProjects={projectsInfo?.subcontractorProjects}
            projectsDetails={projectsInfo?.projectsDetails}
            projectsByStage={projectsInfo?.projectsByStage}
          />
        </Col>
        <Col span={8}>
          <NotesList title={"My Project Notes"} showCard />
        </Col>
      </Row>
    </Flex>
  );
};
